<template>
  <div>
    <top></top>
    <el-carousel style="width: 100%;height: 320px;" indicator-position="none">
      <el-carousel-item style="width: 100%;height: 320px;">
        <img class="swiper-img" src="../../../static/images/swiper2.jpg"/>
      </el-carousel-item>
    </el-carousel>
    <menutree :menuchild="menuchild" checkMenu="3" :rightBars="rightBars"></menutree>
    <div class="aboutus_content_box">
      <div class="aboutus_content">
        <div style="font-weight: bolder;">
          1、环保竣工验收
        </div>
        <p style="text-indent:2em;">
          本机构受建设单位委托，为用人单位依法履行《《建设项目环境保护管理条例》第十九条的规定提供环保竣工验收服务：编制环境影响报告书、环境影响报告表的建设项目，其配套建设的环境保护设施经验收合格，方可投入生产或者使用；未经验收或者验收不合格 的，不得投入生产或者使用。
        </p>
        <div style="font-weight: bolder;">
          2、突发环境事件应急预案
        </div>
        <p style="text-indent:2em;">
          本机构受建设单位委托，为用人单位依法履行《中华人民共和国环境保护法》第四十七条的规定提供突发环境事件应急预案服务：企业事业单位应当按照国家有关规定制定突发环境事件应急预案，报环境保护主管部门和有关部门备案。在发生或者可能发生突发环境事件时，企业事业单位应当立即采取措施处理，及时通报可能受到危害的单位和居民，并向环境保护主管部门和有关部门报告。
        </p>
        <div style="font-weight: bolder;">
          3、排污许可证
        </div>
        <p style="text-indent:2em;">
          本机构受建设单位委托，为用人单位依法履行《中华人民共和国环境保护法》第四十五条的规定提供排污许可证服务：实行排污许可管理的企业事业单位和其他生产经营者应当按照排污许可证的要求排放污染物；未取得排污许可证的，不得排放污染物。
        </p>
      </div>
    </div>
    <bottom></bottom>
  </div>
</template>

<script>
import top from '@/components/top.vue';
import menutree from '@/components/menutree.vue';
import bottom from '@/components/bottom.vue';
export default {
  components:{top,menutree,bottom},
  data () {
    return {
      menuchild:[{
        lable:'职业卫生检测与评价',
        value:'2',
        path:'/occupationalHygiene'
      },{
        lable:'安全技术服务',
        value:'1',
        path:'/safetyAssessment'
      },{
        lable:'环保技术服务',
        value:'3',
        path:'/environmentDetection'
      }],
      rightBars:[{
        lable:'首页',
        path:'/',
      },{
        lable:'服务项目',
        path:'',
      },{
        lable:'环保技术服务',
        path:'',
      }]
    }
  }
}
</script>

<style scope lang="less">
  .swiper-img{
    width: 100%;
    height: 320px;
  }
  .aboutus_content_box{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .aboutus_content{
      width: 1200px;
      min-height: 700px;
      padding:40px 0;
      font-size: 15px;
      color: #666;
      line-height: 35px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/serviceItems/environmentDetection.vue